import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';

import Spinner from '../../atoms/Spinner/Spinner';
import { LandscapeEditStoryTemplate } from '../../templates';
import { StoryResponseDto } from '../../../store/landscapeAPI/story/dto/response/story-response.dto';
import { useNavigate, useParams } from 'react-router-dom';
import {
  fetchStoriesByCompactId,
  fetchStoryById,
  updateStory,
} from '../../../store/landscapeAPI/story/reducers/story.slice';
import { MediaSaveResponseDto } from '../../../store/mediaAPI/media/dto/response/media-save-response';
import { saveMedia } from '../../../store/mediaAPI/media/reducers/media.slice';
import { StoryUpdateRequestDto } from '../../../store/landscapeAPI/story/dto/request/story-update-request.dto';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';

interface LandscapeEditStoryPageProps {}

const LandscapeEditStoryPage: FC<LandscapeEditStoryPageProps> = () => {
  const { id, storyId } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [imageMeta, setImageMeta] = useState<ImageMeta>();
  const { status } = useSelector((state: RootState) => state.storySlice);
  const { status: mediaStatus } = useSelector(
    (state: RootState) => state.mediaSlice
  );
  const [story, setStory] = useState<StoryResponseDto>();

  useEffect(() => {
    if (storyId) {
      dispatch(fetchStoryById(storyId))
        .unwrap()
        .then((response: StoryResponseDto) => setStory(response));
    }
  }, [dispatch, storyId]);

  const handleOnChange = (story: StoryResponseDto) => {
    setStory(story);
  };

  const handleImageOnChange = (imageMeta: ImageMeta) => {
    setImageMeta(imageMeta);
  };

  const callbackFn = async (story: StoryResponseDto) => {
    let image: MediaSaveResponseDto = {
      href: story.headerImage ?? '',
    };
    if (story.headerImage && story.headerImage !== '' && imageMeta) {
      const formData = new FormData();
      formData.append(
        'file',
        new Blob([story.headerImage], {
          type: imageMeta?.imageType ?? 'image/png',
        }),
        imageMeta?.imageSrc
      );
      image = (await dispatch(saveMedia(formData)))
        .payload as MediaSaveResponseDto;
    }
    const storyToUpdate: StoryUpdateRequestDto = {
      name: story.name,
      story: story.story,
      writer: story.writer,
      headerImage: image.href,
      date: story.date,
      compactId: story.compactId,
      id: story.id,
      published: story.published,
    };
    await dispatch(updateStory(storyToUpdate));
    if (id) {
      dispatch(fetchStoriesByCompactId(id));
    }
    navigate(`/landscapes/edit/${id}/updates`);
  };

  if (status === 'loading' || mediaStatus === 'loading') {
    return <Spinner />;
  }

  return (
    <>
      {story && (
        <LandscapeEditStoryTemplate
          story={story}
          handleOnChange={handleOnChange}
          handleImageOnChange={handleImageOnChange}
          callbackFn={callbackFn}
        />
      )}
    </>
  );
};

export default LandscapeEditStoryPage;
